<template>
  <!-- 内容管理-结算规则 -->
  <div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span class="table-btn" @click="edit(row)">详情</span>
            <Poptip
              v-if="showPoptip"
              transfer
              width="200"
              style="margin-left: 10px"
              confirm
              title="当前版本没有有效期，是否先填写？"
              @on-ok="$emit('edit')"
              ok-text="确定"
              cancel-text="取消"
            >
              <span class="table-btn">复制并创建新版本</span>
            </Poptip>
            <span v-else class="table-btn" @click="copyCurrentCommision(row)">复制并创建新版本</span>
            <span class="table-btn" @click="del(row)">删除</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="min">
          <span v-if="row.min == row.max || row.min == 0">{{ row.max }}%</span>
          <span v-else>{{ row.min }}% - {{ row.max }}%</span>
        </template>
      </Table>
    </div>
  </div>
</template>
  
  <script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: ['query', 'showPoptip'],
  data() {
    return {
      userInfo:JSON.parse(window.localStorage.getItem('userInfo')),
      listLoading: false,
      formData: {},
      productForm: {},
      tableData: [],
      columns: [
        {
          title: '版本号',
          key: 'versionNo',
          minWidth: 280,
          align: 'center'
        },
        {
          title: '生效时间',
          key: 'versionStartTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '失效时间',
          key: 'versionEndTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '费率区间',
          slot: 'min',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 250,
          align: 'center',
          fixed: 'right'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    copyCurrentCommision(row) {
      //复制并创建新版本
      this.$emit('callback', { ...row, editType: '3' });
    },
    edit(row) {
      this.$emit('callback', { ...row, editType: '2' });
    },
    del(row) {
      // 可删标识 versionType=-1 历史 和 versionType=1 将来
      this.$notice.inquiry(`确认删除该版本吗？`).then(() => {
        this.$http({
          url: '/buz/commission/version/del',
          type: 'GET',
          data: {
            id: row.id,
            versionNo: row.versionNo
          }
        }).then(res => {
          this.getList();
          this.$notice.success('删除成功');
        });
      });
    },
    // 设置请求方式
    setRequstType() {
      return 'GET';
    },
    init() {
      if (this.userInfo.levelCode == '10001' && this.columns.findIndex(i => i.key == 'updateTime') == -1) {
        this.columns.splice(this.columns.length - 1, 0, {
          title: '更新时间',
          key: 'updateTime',
          minWidth: 180,
          align: 'center'
        });
      }
      this.initListAjax('/buz/commission/version/read/otherVersions');
    },
    // 获取列表参数
    setListParams(params) {
      params.productCode = this.query.productCode;
      if (this.userInfo.levelCode != '10001') {
        params.organizationId = this.userInfo.organId;
      }
    },
    save(list) {
      this.$http({
        url: '/buz/productBase/updateSettleRule',
        type: 'POST',
        data: {
          id: this.productForm.id,
          settleRule: list
        }
      }).then(res => {
        this.tableData = list;
        this.productForm.settleRule = JSON.stringify(this.tableData);
      });
    }
  }
};
</script>
  <style lang="scss" scoped>
</style>
  